import React, { useEffect, useState } from "react";

export default function ResultPage({ result: propResult }) {
  const [result, setResult] = useState(propResult || null);

  useEffect(() => {
    // 🔹 Fallback: load from localStorage if prop is missing
    if (!propResult) {
      const saved = localStorage.getItem("lastResult");
      if (saved) {
        setResult(JSON.parse(saved));
      }
    }
  }, [propResult]);

  if (!result) {
    return <div style={{ padding: 20 }}>No result to show.</div>;
  }

  const { score = 0, total = 0, wrongAnswers = [] } = result;
  const percent = total ? Math.round((score / total) * 100) : 0;

  return (
    <div
      className="result-wrapper fade-in"
      style={{ "--percent": percent }}
    >
      {/* ===== HEADER ===== */}
      <div className="result-header">
        <h2>Test Result</h2>

        <div className="score-ring">
          <span>{percent}%</span>
        </div>

        <div className="score-meta">
          <p>
            <strong>Score:</strong> {score}/{total}
          </p>
          <p>
            <strong>Accuracy:</strong> {percent}%
          </p>
        </div>
      </div>

      {/* ===== WRONG ANSWERS ===== */}
      <div className="wrong-section">
        <h3 className="section-title">Answer Review</h3>

        {wrongAnswers.length === 0 ? (
          <p className="perfect-msg">
            🎉 Excellent! No mistakes in this test.
          </p>
        ) : (
          wrongAnswers.map((wa, idx) => (
            <div
              key={wa.questionId || idx}
              className="wrong-card"
            >
              <div className="wrong-question">
                <span className="wrong-q-index">
                  Q{idx + 1}.
                </span>{" "}
                {wa.questionText || "Question not available"}
              </div>

              <div className="wrong-row">
                <span className="icon wrong-icon">✖</span>
                <span className="wrong-label">Your Answer:</span>
                <span>
                  {wa.selectedText ??
                    (typeof wa.selectedIndex === "number"
                      ? `Option ${wa.selectedIndex + 1}`
                      : "No answer selected")}
                </span>
              </div>

              <div className="wrong-row">
                <span className="icon correct-icon">✔</span>
                <span className="wrong-label">Correct Answer:</span>
                <span>
                  {wa.correctText ??
                    (typeof wa.correctIndex === "number"
                      ? `Option ${wa.correctIndex + 1}`
                      : "Unknown")}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
